import SignupFormModel from '../../components/FormBuilder/SignupFormModel';
import { GetVendorList_season_signupForm_fields as Field } from '../../components/Vendors/__generated__/GetVendorList';
import { ID_FIELD_CATEGORY } from '../../core/constants/SignupForm';
import {
  MultichoiceElementDefinitionRuntype,
  Option,
} from '../../runtypes/SignupFormDefinitionRuntype';
import { toMap } from './toMap';

export function getOptionsFromDefinition(value: unknown) {
  return MultichoiceElementDefinitionRuntype.guard(value) ? value.options : [];
}

export function getCategoryOptionsFromGraphQLFields(fields: Array<Field>) {
  const categoryDefinition =
    fields.find((field) => field.id === ID_FIELD_CATEGORY)?.definition ?? '{}';
  const rawCategoryField = JSON.parse(String(categoryDefinition));
  const options = getOptionsFromDefinition(rawCategoryField);
  return options;
}

export function getCategoryOptionsFromFields(
  fields: SignupFormModel['fields'],
) {
  const categoryDefinition = fields.find(
    (field) => field.id === ID_FIELD_CATEGORY,
  )?.definition;
  const options = getOptionsFromDefinition(categoryDefinition);
  return options;
}

export type OptionsMap = Map<string, Option>;

export function getOptionFields(formDef: SignupFormModel) {
  const optionFields = new Map<string, OptionsMap>();
  for (const field of formDef.fields.getList()) {
    const { definition } = field;
    if (definition.type === 'MultichoiceElement') {
      const { id, options } = definition;
      optionFields.set(id, toMap((options ?? []) as Array<Option>));
    }
  }
  return optionFields;
}
